import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=37ff3cdc&scoped=true&"
import script from "./Solutions.vue?vue&type=script&setup=true&lang=js&"
export * from "./Solutions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff3cdc",
  null
  
)

export default component.exports